<template>
  <div></div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      vueroutename: "components",
      apicomponentname: "base",
      step: 0,
      raw: false,
      parent: false,
      current: false,
      ranInit: false,
      intervalforBG: false,
      intervalCounter: 0,
      showFooter: true
    };
  },
  created() {
    this.checkHeader();
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      
      this.parent = this.$route.params.parent;
      this.current = this.$route.params.current;
      if (!this.current && this.parent == "contents") {
        this.current = "startseite";
      }
      if (!this.current && !this.parent) {
        this.parent = "contents";

        this.current = "startseite";
      }

      if (
        this.$route.path.replace("/" + this.$route.params.autoitem, "") ==
        "/unsere-rezepte/rezept-archiv"
      ) {
        this.parent = "contents";
        this.current = "rezept-archiv";
      }
      this.getList();
    },
    getList(full = false) {
      let apiurl =
        this.$APIURL + this.$APIVERSION + "/" + this.apicomponentname + "/";

      // if (
      // 	this.$route.params.parent == "wissen" ||
      // 	this.$route.params.parent == "aktuelles"
      // ) {
      // 	apiurl += this.$route.params.parent + this.current;
      // } else {
      if (this.current && !full) {
        apiurl += this.current;
      }
      if (this.$route.params.autoitem && !full) {
        apiurl += "?item=" + this.$route.params.autoitem;
      }
      // }
      let apiurlq = "";
      apiurl += apiurlq;

      axios
        .get(apiurl, {})
        .then(response => {
          if ((this.raw = response.data)) {
            if (!this.ranInit) {
              this.ranInit = true;
              this.postInit();
              this.checkSlider();
              this.showFooter = true;
              setTimeout(() => {
                this.checkWrapper();
              }, 100);
            }
            this.setCampaignSite();
            this.initCampaignBacklink();
            if (this.apicomponentname == "contents" ) {
              
              
                document
                  .querySelector('meta[name="description"]')
                  .setAttribute(
                    "content",
                    response.data.data.attributes.description ? 
response.data.data.attributes.description 
                     :"Amecke | " +
                (response.data.data.attributes.pageTitle
                  ? response.data.data.attributes.pageTitle
                  : response.data.data.attributes.title)
                  );
              
              if (response.data.data.attributes.metakeywords) {
                document
                  .querySelector('meta[name="keywords"]')
                  .setAttribute(
                    "content",
                    response.data.data.attributes.metakeywords
                  );
            
              }
            }
              document
                  .querySelector('base')
                  .setAttribute(
                    "href",
                    location.origin
                  );
              document
                  .querySelector('meta[name="robots"]')
                  .setAttribute(
                    "content",
                    response.data.data.attributes.robots ? 
                    response.data.data.attributes.robots: 'noindex,nofollow'
                  );
              document.title =
                "Amecke | " +
                (response.data.data.attributes.pageTitle
                  ? response.data.data.attributes.pageTitle
                  : response.data.data.attributes.title);
            
          }

          if (
            this.raw.data.attributes &&
            this.raw.data.attributes.productsInCateogry
          ) {
            let index = this.raw.data.attributes.productsInCateogry.findIndex(
              x => x.alias === this.raw.data.attributes.alias
            );
            this.raw.data.attributes.coverslideindex = index;
          }
        })
        .catch(function(error) {
          console.error(error);
          if (error.response && error.response.status == 302) {
            window.location.reload();
          }
          if (error.response && error.response.status == 401) {
            window.location.href = "/";
          }
        });
    },
    onLoaded(event) {},
    setCampaignSite() {
      let elem = document.querySelector("body");
      elem.classList.remove("site-campaign");
      elem.classList.remove("site-campaign-red");
      elem.classList.remove("site-campaign-yellow");
      elem.classList.remove("site-campaign-start");

      if (this.raw.data && this.raw.data.attributes.isCampaingsite) {
        elem.classList.add("site-campaign");
        // set body-class
        let campaignType = this.raw.data.attributes.campaignselect;
        let campaignClass = "site-campaign-" + campaignType;
        elem.classList.add(campaignClass);

        // set campaign logo src
        let headerLogoElem = document.getElementById("headerlogo");
        let footerLogoElem = document.getElementById("footerlogo");

        if (campaignType == "red" && headerLogoElem && footerLogoElem) {
          headerLogoElem.src =
            "files/images/Aktionen/jolly-days/campaign-logo-red.png";
          footerLogoElem.src =
            "files/images/Aktionen/jolly-days/campaign-logo-red.png";
        }
        if (campaignType == "yellow" && headerLogoElem && footerLogoElem) {
          headerLogoElem.src =
            "files/images/Aktionen/jolly-days/campaign-logo-yellow.png";
          footerLogoElem.src =
            "files/images/Aktionen/jolly-days/campaign-logo-yellow.png";
        }
        if (campaignType == "start" && headerLogoElem && footerLogoElem) {
          footerLogoElem.src =
            "files/images/Aktionen/jolly-days/campaign-logo-beige.png";
        }
      }
    },
    checkHeader() {
      var elem = document.querySelector("main div > div");
      if (!elem) {
        elem = document.querySelector("main div > section");
      }
      if (!elem) {
        return;
      }

      // if (
      // 	(!elem.classList.contains("ce-slider") &&
      // 		!elem.classList.contains("ce-image")) ||
      // 	elem.classList.contains("content-wrapper")
      // ) {
      // 	elem = document.querySelector("body");
      // 	elem.classList.add("spacetop");
      // }
    },
    convertHex(color) {
      color = color.replace("#", "");
      let r = parseInt(color.substring(0, 2), 16);
      let g = parseInt(color.substring(2, 4), 16);
      let b = parseInt(color.substring(4, 6), 16);
      let result = "rgba(" + r + "," + g + "," + b + "," + 80 / 100 + ")";
      return result;
    },
    postInit() {},
    initCampaignBacklink() {
      // campaign back link
      setTimeout(() => {
        let campaignBackBtn = document.querySelector("a.campaign-backlink");
        if (campaignBackBtn) {
          var objVM = this;
          campaignBackBtn.addEventListener("click", event => {
            event.preventDefault();
            let currentUrl = campaignBackBtn.getAttribute("href");
            objVM.gotoPage(currentUrl);
          });
        }
      }, 500);
    },
    gotoPage(url) {
      this.$router.push(url);
    },
    arrayRemove(arr, value) {
      return arr.filter(function(ele) {
        return ele != value;
      });
    },
    getHeadline(type = "h2", value, centered) {
      let headlineClass = "";
      if (centered == "1") {
        headlineClass = " class='text-center'";
      }
      if (value != "") {
        switch (type) {
          case "h1":
            return "<h1" + headlineClass + ">" + value + "</h1>";
            break;
          case "h2":
            return "<h2" + headlineClass + ">" + value + "</h2>";
            break;
          case "h3":
            return "<h3" + headlineClass + ">" + value + "</h3>";
            break;
          case "h4":
            return "<h4" + headlineClass + ">" + value + "</h4>";
            break;
          case "h5":
            return "<h5" + headlineClass + ">" + value + "</h5>";
            break;
        }
      } else {
        return false;
      }
    },
    checkPlayVideo(event) {
      var b = setInterval(() => {
        var elem = document.querySelector(
          "li.hooper-slide.slider-item--video.is-active video"
        );
        if (elem) {
          if (elem.readyState >= 3) {
            if (!elem.playing) {
              elem = elem;
              elem.play();
            }
            clearInterval(b);
          }
        }
      }, 500);

      if (typeof hooper !== "undefined") {
        hooper.restart();
      }
    },
    checkSlider(event) {
      if (typeof hooper !== "undefined") {
        hooper.restart();
      }
      setTimeout(() => {
        this.nextSlideHeight("init");
      }, 100);
    },
    getBaseUrl() {
      var getUrl = window.location;
      var baseUrl =
        getUrl.protocol +
        "//" +
        getUrl.host +
        "/" +
        getUrl.pathname.split("/")[1];
      return baseUrl;
    },
    getBaseUrlFolder() {
      var getUrl = window.location;
      var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
      let arrPath = this.$route.path.split("/");
      return arrPath.splice(0, arrPath.length - 1).join("/");
    },
    nextSlideHeight(event) {
      if (typeof event == "string") {
        var indexitem = 0;
        var direction = "right";
      } else if (typeof event == "object") {
        var indexitem = event.currentSlide;
        var direction = event.currentSlide > event.slideFrom ? "right" : "left";
      } else {
        return;
      }

      // clearInterval(this.intervalforBG);

      var elems = document.querySelectorAll(".slider-background");
      [].forEach.call(elems, el => {
        // el.style.opacity = 0;
        el.classList.remove("js-active");
      });
      var elem = document.querySelector("li.hooper-slide.is-active");
      if (elem) {
        var count = document.querySelectorAll(
          "li.hooper-slide.slide-item:not(.is-clone)"
        ).length;

        if (indexitem < 0) {
          indexitem = count - 1;
        }
        if (indexitem == count) {
          indexitem = 0;
        }
        var activeSlide = document.querySelectorAll(
          "li.hooper-slide.slide-item:not(.is-clone)"
        )[indexitem];
        var elemVideo = document.querySelector(
          "li.hooper-slide.slider-item--video.is-active video"
        );
        if (elem && activeSlide) {
          elem.style.height = activeSlideHeight + "px";
          var activeSlideHeight = activeSlide.getBoundingClientRect().height;

          if (activeSlide.classList.contains("slider-item--video")) {
            activeSlideHeight = "550";
          }

          elem = document.querySelector(".hooper.slider-wrapper");
          elem.style.height = activeSlideHeight + "px";
          elem = document.querySelector(".hooper-list");
          elem.style.height = activeSlideHeight + "px";

          var elemBG = document.querySelector(
            '[data-bg-item="' + indexitem + '"]'
          );

          if (elemBG) {
            elemBG.classList.add("js-active");
          }
        }
      }
    },
    checkWrapper() {
      // element that will be wrapped
      var elems = document.querySelectorAll(".wrapperitem");
      let arrElements = [];
      let wrapper = false;
      let strRel = "";
      let elementStart = false;

      [].forEach.call(elems, el => {
        if (el.classList.contains("wrapperstart")) {
          elementStart = el;
          strRel = "";
          if (el.attributes.rel) {
            strRel = el.attributes.rel.value + "-wrapper";
          }
          // create wrapper container
          if (
            !elementStart.parentNode.classList.contains("wrapper") &&
            elementStart.classList.contains("tab--item")
          ) {
            if (strRel == "tab-wrapper") {
              wrapper = document.createElement("div");
              wrapper.classList.add(strRel);
              elementStart.parentNode.insertBefore(wrapper, elementStart);
            }
          } else {
            wrapper = document.querySelector(".seasonwrapper .content");
            if (wrapper) {
              wrapper.parentNode.appendChild(elementStart);
            }
          }
          // insert wrapper before el in the DOM tree
        }
        arrElements.push(el);
        if (el.classList.contains("wrapperend")) {
          // move el into wrapper

          if (arrElements.length > 0 && wrapper) {
            [].forEach.call(arrElements, element => {
              wrapper.appendChild(element);
            });
            arrElements = [];
          }
          var elem = document.querySelector(".seasonwrapper.bg-wrapper");
          if (elem) {
            // elem.style.height = "1300px";
            elem.style.padding = "150px 0";
          }
          elem = null;
          if (strRel == "tab-wrapper") {
            wrapper = false;
          }
        }
      });
    },

    fadeIn(elementToFade) {
      // 	var element = elementToFade;
      // 	element.style.opacity += 0.1;
      // 	if (element.style.opacity > 1.0) {
      // 		element.style.opacity = 1.0;
      // 	} else {
      // 		setTimeout(this.fadeIn(elementToFade), 100);
      // 	}
    },

    inViewport(el) {
      var rect = el.getBoundingClientRect(),
        vWidth = window.innerWidth || doc.documentElement.clientWidth,
        vHeight = window.innerHeight || doc.documentElement.clientHeight,
        efp = function(x, y) {
          return document.elementFromPoint(x, y);
        };

      // Return false if it's not in the viewport
      if (
        rect.right < 0 ||
        rect.bottom < 0 ||
        rect.left > vWidth ||
        rect.top > vHeight
      )
        return false;
      // Return true if any of its four corners are visible
      return true;
      return (
        el.contains(efp(rect.left, rect.top)) ||
        el.contains(efp(rect.right, rect.top)) ||
        el.contains(efp(rect.right, rect.bottom)) ||
        el.contains(efp(rect.left, rect.bottom))
      );
    },

    findAncestor(el, sel) {
      while ((el = el.parentElement) && !el.classList.contains(sel));
      return el;
    },
    findChild(el, sel) {
      while ((el = el.lastChild) && !el.classList.contains(sel));
      return el;
    },
    getOffset(el) {
      const rect = el.getBoundingClientRect();

      return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset
      };
    },
    toggleAccordion(event) {
      let currentHeader = document.querySelector(".site-header");
      let currentHeaderHeight = currentHeader.offsetHeight;

      let currentAccElement = this.findAncestor(event.target, "ce-accordion");

      if (currentAccElement.classList.contains("js-active")) {
        this.closeAllAccordions();
      } else {
        // close all navigation
        this.closeAllAccordions();
        currentAccElement.classList.add("js-active");
        // let accTopPos =
        //   this.getOffset(currentAccElement).top - currentHeaderHeight;
        // window.scrollTo({
        //   top: accTopPos,
        //   left: 0,
        //   behavior: "smooth"
        // });
      }
    },
    scrollToNode (element, startOrEnd = 'start') {
      if (typeof element === 'string' || element instanceof String) {
        element = document.getElementById(element)
      }
      if (element) {
        element.scrollIntoView({
          block: startOrEnd,
          behavior: 'smooth'
        })
      }
    },
    closeAllAccordions() {
      let allAccordions = document.querySelectorAll(".ce-accordion");
      if (allAccordions) {
        [].forEach.call(allAccordions, el => {
          el.classList.remove("js-active");
        });
      }
    },
    fieldAutoGrow(event) {
      event.target.style.height = "5px";
      event.target.style.height = event.target.scrollHeight + "px";
    },
    validateFormAndSendForm() {
      let formid = "complaintform";
      let myForm = document.getElementById(formid);
      if (!myForm) {
        formid = "contactform";
        myForm = document.getElementById(formid);
      }
      let formData = new FormData();
      let formDataelement = new FormData(myForm);
      for (let field of formDataelement.keys()) {
        formData.append(field, formDataelement.get(field));
      }
      formData.append("formid", formid);
      let apiurl = this.$APIURL + this.$APIVERSION + "/submitform";

      let callmethod = document
        .getElementById(formid)
        .getAttribute("method")
        .toLowerCase();

      axios
        .post(apiurl, formData)
        .then(response => {
          if (response.data.data == true) {
            myForm.reset();
            this.submitted = true;
          }
        })
        .catch(error => {});
      setTimeout(() => {
        this.submitted = false;
      }, 10000);
    }
    /*
							buildTabs() {
								var tabs = document.querySelectorAll(".tab-wrapper");
								// Find all tab-wrapper on page
								if (tabs.length < 1) {
									return false;
								}
								tabs.forEach.call(tabs, tab => {
									var tabsContent = document.createElement("div");
									tabsContent.classList.add("tab-contents");

									var tabsNavigation = document.createElement("div");
									tabsNavigation.classList.add("tab-navigation");

									var tabInner = document.createElement("div");
									tabInner.classList.add("content-wrapper");

									var tabInnerWrapper = document.createElement("div");
									tabInnerWrapper.classList.add("tab-content--wrapper");
									var tabInnerWrapperContentHtml = "";
									var tabNavigationContentHtml = "";

									let children = tab.childNodes;
									
									children.forEach(function(value, key) {
										var newKey = key + 1;
										let backgroundimageElement = value.querySelector(
											".tabbackgroundimage"
										);
										let backgroundimage = "";
										if (backgroundimageElement) {
											backgroundimage = backgroundimageElement.src;
										}
										let headline = value.querySelector(".headline").textContent;
										let text = value.querySelector(".text").textContent;
										let tabtext = value.querySelector(".tabtext").textContent;
										let productimage = value.querySelector(".tabproductimage")
											.src;
										let sloganimage = value.querySelector(".tabsloganimage")
											.src;
										let tabimage = value.querySelector(".tabimage").src;

										var tabBg = document.createElement("div");
										tabBg.classList.add("tab-content--bg", "animated");
										tabBg.setAttribute(
											"style",
											"background-image: url(" + backgroundimage + ")"
										);
										tabBg.setAttribute("data-bg-item", newKey);

										tabInnerWrapperContentHtml +=
											'<div id="tabcontent-' +
											newKey +
											'" class="tab-content"><div class="tab-content--slogan animated delay-025s"><img src="' +
											sloganimage +
											'" alt="slogan"></div><div class="tab-content--image animated delay-05s"><img src="' +
											productimage +
											'" alt=""></div><div class="tab-content--info animated delay-075s"><h4>' +
											headline +
											"</h4>" +
											"<p>" +
											text +
											"</p>" +
											'<a href="#" class="btn btn-circle"><span>Mehr entdecken</span></a></div></div>';
										tabInner.appendChild(tabInnerWrapper);
										tabsContent.appendChild(tabBg);

										tabNavigationContentHtml +=
											'<button class="tab-links" data-tab-item="' +
											newKey +
											'"><img src="' +
											tabimage +
											'" alt="' +
											tabtext +
											'"><h5>' +
											tabtext +
											"</h5></button>";
									});
									tabInnerWrapper.innerHTML = tabInnerWrapperContentHtml;
									tabsNavigation.innerHTML = tabNavigationContentHtml;
									tabsContent.appendChild(tabInner);

									tab.innerHTML = "";
									tab.appendChild(tabsContent);
									tab.appendChild(tabsNavigation);

									this.initTabsAnimation();
								});
							},
							initTabsAnimation() {
								let elemsTab = document.querySelectorAll(
									".tab-navigation .tab-links"
								);
								let animationDelay = 900;

								this.openFirst(1, animationDelay);

								[].forEach.call(elemsTab, el => {
									el.addEventListener("click", event => {
										if (
											!event.toElement.parentNode.classList.contains(
												"js-active"
											)
										) {
											let currentTabItem = event.toElement.parentNode.getAttribute(
												"data-tab-item"
											);
											this.animateTabContentOut();
											setTimeout(() => {
												this.animateTabContentIn(
													currentTabItem,
													animationDelay
												);
											}, 900);
											setTimeout(() => {
												this.animateTabBackground(
													currentTabItem,
													animationDelay
												);
											}, 1200);
										}
									});
								});
							},
						openFirst(p_tabItem, p_animationDelay) {
							let delay = p_animationDelay;
							setTimeout(() => {
								this.animateTabContentIn(p_tabItem, delay);
							}, 600);
							setTimeout(() => {
								this.animateTabBackground(p_tabItem, delay);
							}, 900);
						},
						animateTabBackground(p_tabLinkItem, p_animationDelay) {
							let classBgAnimateIn = "fadeIn";
							let classBgAnimateOut = "fadeOut";
							// fadeout all backgrounds
							let allTabContents = document.querySelectorAll(
								"div[id*=tabcontent-]"
							);
							let allTabBackgrounds = document.querySelectorAll(
								".tab-content--bg.animated." + classBgAnimateIn
							);
							[].forEach.call(allTabContents, elCon => {
								elCon.classList.remove("js-active");
							});
							// [].forEach.call(allTabBackgrounds, elBg => {
							// 	elBg.classList.add(classBgAnimateOut);
							// });
							this.clearAllTabs(p_animationDelay);
							// show current Tab an Background
							let currentTabElem = document
								.querySelector("#tabcontent-" + p_tabLinkItem)
								.getBoundingClientRect();
							
							let currentTabElemHeight = currentTabElem.height;

							document.querySelector(".tab-content--wrapper").style.height =
								currentTabElemHeight + "px";
							document.querySelector(".tab-contents").style.height =
								currentTabElemHeight + "px";
							document
								.querySelector("#tabcontent-" + p_tabLinkItem)
								.classList.add("js-active");
							//fade bg out
							[].forEach.call(allTabBackgrounds, elBg => {
								elBg.classList.add(classBgAnimateOut);
							});
							// fade bg in
							document
								.querySelector(
									'.tab-content--bg[data-bg-item="' + p_tabLinkItem + '"]'
								)
								.classList.add(classBgAnimateIn);
						},
						animateTabContentOut() {
							let classAnimateOut = "fadeOutLeftBig";
							let allActiveElemens = document.querySelectorAll(
								".tab-content .animated.fadeInRightBig"
							);
							[].forEach.call(allActiveElemens, el => {
								el.classList.add(classAnimateOut);
							});
						},
						animateTabContentIn(p_tabLinkItem, p_delay) {
							let classAnimateIn = "fadeInRightBig";
							// clear old animation-classes
							// setTimeout(() => {
							let allCurrentContent = document.querySelectorAll(
								"#tabcontent-" + p_tabLinkItem + "> .animated"
							);
							[].forEach.call(allCurrentContent, elCon => {
								elCon.classList.add(classAnimateIn);
							});
							// }, p_delay);
						},
						clearAllTabs(p_animationDelay) {
							let delay = p_animationDelay + 100;
							setTimeout(() => {
								let allOutfadedBackgrounds = document.querySelectorAll(
									".tab-content--bg.animated.fadeIn.fadeOut"
								);
								[].forEach.call(allOutfadedBackgrounds, el => {
									el.classList.remove("fadeIn", "fadeOut");
								});
							}, delay);
							let allOutfadedContents = document.querySelectorAll(
								".animated.fadeInRightBig.fadeOutLeftBig"
							);
							[].forEach.call(allOutfadedContents, el => {
								el.classList.remove("fadeInRightBig", "fadeOutLeftBig");
							});
						}
						*/
  },
  watch: {
    $route(to, from) {
      
        if (to && to.path =='/mehr-leben') {
      document.body.classList.add('mehr-leben')

        } else {
      document.body.classList.remove('mehr-leben')

        }
      let arrElements = document.querySelectorAll(".tab-wrapper");
      if (arrElements.length > 0) {
        [].forEach.call(arrElements, element => {
          element.parentNode.removeChild(element);
        });
      }
      setTimeout(() => {
        this.checkHeader();
        // this.checkWrapper();
      }, 100);
      this.setCampaignSite();
      this.initCampaignBacklink();
      // document.querySelector("body").classList.remove("spacetop");
      window.scrollTo({
        top: 0,
        left: 0
        // behavior: "smooth"
      });
      setTimeout(() => {
        this.checkWrapper();
      }, 500);
    }
  }
};
</script>

<style lang="scss">
// body.spacetop {
// 	margin-top: 152px;
// }
</style>